import { useState, useCallback, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { updateLeadNextActionDate } from '../api'
import { ILeadNextActionDateUpdate } from '../typings'

export const useUpdateLeadNextActionDate = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const [toUpdate, setToUpdate] = useState<ILeadNextActionDateUpdate>()

  const execute = useCallback(
    (update: ILeadNextActionDateUpdate) => {
      if (status != 'pending') {
        setToUpdate(update)
      }
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (toUpdate) {
        try {
          setStatus('pending')
          const result = await dispatch(updateLeadNextActionDate(toUpdate))

          if (mounted) {
            if (updateLeadNextActionDate.fulfilled.match(result)) {
              setStatus('success')
            } else {
              setStatus('fail')
              toast.error(`Unable to update lead next action date.`)
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
            toast.error(error.Message)
          }
        } finally {
          setToUpdate(undefined)
          setStatus('idle')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, toUpdate])

  return { status, execute }
}
